import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import flagGreece from "@/assets/flag-greece.png";
import flagUK from "@/assets/flag-uk.png";

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === "el" ? "en" : "el");
  };

  return (
    <Button 
      variant="ghost" 
      size="sm" 
      className="gap-2 px-2"
      onClick={toggleLanguage}
      aria-label={language === "el" ? "Switch to English" : "Αλλαγή σε Ελληνικά"}
    >
      <img 
        src={language === "el" ? flagGreece : flagUK} 
        alt={language === "el" ? "Ελληνικά" : "English"}
        className="h-5 w-7 object-cover rounded-sm"
      />
      <span className="uppercase font-semibold text-sm">
        {language === "el" ? "EL" : "EN"}
      </span>
    </Button>
  );
};

export default LanguageSelector;
